import classNames from "classnames"
import { values } from "lodash"
import PropTypes from "prop-types"
import React from "react"

import { htmlType } from "../constants/index.es6"

import styles from "./html.less"

const Html = (props) => {
  const { children, className, dataSortableContainerId, type, ...rest } = props

  switch (type) {
    case htmlType.table:
      return (
        <tbody className={className} data-sortable-container-id={dataSortableContainerId} {...rest}>
          {children}
        </tbody>
      )

    case htmlType.div:
      return (
        <div
          className={classNames(styles.div, className)}
          data-sortable-container-id={dataSortableContainerId}
          {...rest}
          role="rowgroup">
          {children}
        </div>
      )

    default:
      throw Error(`Type "${type}" not supported`)
  }
}

Html.propTypes = {
  type: PropTypes.oneOf(values(htmlType)),
  className: PropTypes.string,
  dataSortableContainerId: PropTypes.string,
}

Html.defaultProps = {
  type: htmlType.div,
}

export default Html
